module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAAABHNCSVQICAgIfAhkiAAAAMZJREFUSInF1NERgyAMgOEfO4On4+Bk1Uk6Co6jxxD0oTkPWlQUsbnzJSJfiFHFDWFbNA6DYnjcgPU4XqWdBbMNTi5TEtK2wdyF+af6P6Yuwz6bay811jPd97oqG5JTpWD+Q3r1ZgJ26J3JRDnb0hfHACXt8DJ09cS4VSAuuvF2GyUqFEOQcRjbYGJtlr/GaSzYKNKeoM0pa1Ji+Syk+meselgZKsVQTyfBHfQS7AdMRk9iUXAXzcA2IzokBwckDy2NBeiF2Bu5cKddw/1nNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img39.png
// module id = yvUV
// module chunks = 1